"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Dropdown = require("./Dropdown.style"); // Parent needs to be positioned relatively for the dropdown to align itself to it


var Dropdown = function Dropdown(_ref) {
  var children = _ref.children,
      direction = _ref.direction,
      isOpened = _ref.isOpened,
      width = _ref.width,
      rest = _objectWithoutProperties(_ref, ["children", "direction", "isOpened", "width"]);

  if (!children) {
    return null;
  }

  var motionProps = {
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    initial: {
      opacity: 0
    }
  };
  return isOpened ? /*#__PURE__*/_react.default.createElement(_Dropdown.Container, Object.assign({
    direction: direction
  }, rest, motionProps), /*#__PURE__*/_react.default.createElement(_Dropdown.Wrapper, {
    width: width
  }, children)) : null;
};

Dropdown.propTypes = {
  children: _propTypes.default.arrayOf(_propTypes.default.node),
  direction: _propTypes.default.oneOf(['left', 'right']),
  isOpened: _propTypes.default.bool,
  width: _propTypes.default.string
};
Dropdown.defaultProps = {
  children: null,
  direction: 'left',
  isOpened: false,
  width: '35rem'
};
var _default = Dropdown;
exports.default = _default;